import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    h: "1. Titolare del trattamento",
    p: "Manuel Faustini — Consulente Finanziario Autonomo iscritto all'Albo OCF, con sede operativa in Bergamo, email: faustinimanuelcfa@gmail.com.",
  },
  {
    h: "2. Dati raccolti",
    p: "Tramite il form di contatto vengono raccolti: nome e cognome, indirizzo email, numero di telefono (facoltativo) e il contenuto del messaggio. Ulteriori dati possono essere conferiti spontaneamente dall'utente in fase di colloquio.",
  },
  {
    h: "3. Finalità e base giuridica",
    p: "I dati vengono trattati esclusivamente per dare riscontro alla richiesta dell'utente e per le successive comunicazioni connesse al servizio di consulenza. La base giuridica è il consenso espresso al momento dell'invio del modulo (art. 6.1.a GDPR) e l'esecuzione di misure precontrattuali (art. 6.1.b GDPR).",
  },
  {
    h: "4. Modalità del trattamento",
    p: "I dati sono trattati con strumenti elettronici, conservati su database protetto e accessibili unicamente al titolare. Non sono soggetti a processi decisionali automatizzati né a profilazione.",
  },
  {
    h: "5. Conservazione",
    p: "I dati sono conservati per il tempo strettamente necessario alla gestione della richiesta e, in caso di avvio di un rapporto professionale, per la durata prevista dalla normativa di settore (Albo OCF, antiriciclaggio, fiscale).",
  },
  {
    h: "6. Comunicazione e diffusione",
    p: "I dati non saranno diffusi né ceduti a terzi. Potranno essere comunicati a soggetti che svolgono attività necessarie all'erogazione del servizio (es. consulente fiscale, notaio) solo previo consenso dell'interessato.",
  },
  {
    h: "7. Diritti dell'interessato",
    p: "L'utente ha diritto di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione al trattamento dei propri dati, oltre al diritto di proporre reclamo al Garante per la Protezione dei Dati Personali. Per esercitare i propri diritti è sufficiente scrivere a faustinimanuelcfa@gmail.com.",
  },
];

const PrivacyPolicy = () => {
  return (
    <main data-testid="privacy-page" className="bg-ivory text-navy min-h-screen pt-24">
      <div className="container-editorial py-20 md:py-28 max-w-3xl">
        <Link
          to="/"
          data-testid="back-home"
          className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-muteText hover:text-navy mb-12"
        >
          <ArrowLeft size={14} /> Torna alla home
        </Link>

        <p className="overline mb-6">Informativa</p>
        <h1 className="display-2 mb-10">Privacy Policy</h1>
        <p className="lede mb-12">
          La presente informativa è resa ai sensi dell'art. 13 del Regolamento UE
          2016/679 (GDPR) e del D.lgs. 196/2003 e successive modifiche.
        </p>

        <div className="space-y-10">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-serif text-2xl md:text-3xl mb-3">{s.h}</h2>
              <p className="text-muteText leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>

        <p className="text-xs tracking-[0.22em] uppercase text-muteText mt-16">
          Ultimo aggiornamento: dicembre 2025
        </p>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
